import { FC } from 'react'
import { ApplicationFrame } from '../../components/ApplicationFrame'
import { Typography } from '@mui/material'

/**
 * Simulated Delivery Application
 */
export const DeliverySimulator: FC = () => {
  return (
    <ApplicationFrame heroImage={''} backgroundColor="#eae8e8">
      {/* Centralised Title with padding */}
      <Typography variant="h4" align="center" sx={{ p: 2 }}>
        Simulated Delivery
      </Typography>
    </ApplicationFrame>
  )
}
